import React, { Component } from "react";


import "../css/patients.css"
import leftquote from "../images/left-quote.svg"


class PatientSuccessStories extends React.Component{
    constructor()
    {
        super()
        this.state={
            
        }
    }
    
    render(){
        
      return(
        <section className="patients-stories-sec">
        <div className="container-fluid">
            <div className="patients-stories-inner">
                <div className="row">
                    <div className="col-12">
                        <div className="title">
                            <h2>Real Patients. Real Stories</h2>
                            {/* <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut </p> */}
                        </div>
                        <div className="swiper-container patients-stories">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="patients-stories-box">
                                        <div className="text-box">
                                            <img src={leftquote} alt="" />
                                            <p>In 3 months, my glucose levels dropped from 250 to 120. At 78, I feel like 28 in energy and younger by the day, thanks to Twin</p>
                                        </div>
                                        <div className="patients-stories-bottom">
                                            <div className="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605081873/NewHome/Meera-min_lvtheb.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                            <div className="text-inner">
                                                <h4>Meera</h4>
                                                <p>Long time diabetic, Now reversed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="patients-stories-box">
                                        <div className="text-box">
                                            <img src={leftquote} alt="" />
                                            <p>My happiness knew no limits when my glucose levels dropped from 430 to 100 without taking any medicines.</p>
                                        </div>
                                        <div className="patients-stories-bottom">
                                            <div className="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605081873/NewHome/Yusuf-min_pfr0wr.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                            <div className="text-inner">
                                                <h4 className="orange-color">Yusuf</h4>
                                                <p>3 years diabetic, Now reversed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="patients-stories-box">
                                        <div className="text-box">
                                            <img src={leftquote} alt="" />
                                            <p>I am aging in reverse since I started my treatment. My blood sugar reduced from 250 to140 without any medicines & my joint pain too went away</p>
                                        </div>
                                        <div className="patients-stories-bottom">
                                            <div className="image-holder">
                                                <img data-src="https://res.cloudinary.com/image/upload/v1605081873/NewHome/Prakash-min_n2oksb.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                            <div className="text-inner">
                                                <h4 className="green-color">Gnana Kumar</h4>
                                                <p>8 Years diabetic, Now reversed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="swiper-slide">
                                    <div className="patients-stories-box">
                                        <div className="text-box">
                                            <img src={leftquote} alt="" />
                                            <p>The Twin treatment is such a blessing to mankind! In my first few weeks, all my medicines were stopped & my glucose readings were between 118-120</p>
                                        </div>
                                        <div className="patients-stories-bottom">
                                            <div className="image-holder">
                                            <img data-src="https://res.cloudinary.com/image/upload/v1605081873/NewHome/Kailasam-min_fif7pd.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                            <div className="text-inner">
                                                <h4 className="orange-color">Kailasam</h4>
                                                <p>14 years diabetic, Now reversed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="patients-stories-box">
                                        <div className="text-box">
                                            <img src={leftquote} alt="" />
                                            <p>I teared up with joy when my glucose levels dropped from 263 to 109 & I lost 16 kg’s without medicines.</p>
                                        </div>
                                        <div className="patients-stories-bottom">
                                            <div className="image-holder">
                                            <img data-src="https://res.cloudinary.com/image/upload/v1605081873/NewHome/Munzoor-min_zukhvl.png" alt="" className="img-fluid lazyload" />
                                            </div>
                                            <div className="text-inner">
                                                <h4 className="green-color">Munzoor, Avid traveller</h4>
                                                <p>13 years diabetic, Now reversed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Add Pagination */}
                            <div className="swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
    </section>
           
        )
    }
}
export default PatientSuccessStories;